import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RTL_LANGUAGES } from '@klareospace/pharos-lib-front-utils';

type Direction = 'ltr' | 'rtl';

/**
 * Syncs document.documentElement.lang and dir attributes with the current i18n language.
 * Returns the computed direction so callers can pass it to Radix's DirectionProvider.
 * Call this once in the root layout component.
 */
export function useDocumentLanguage(): Direction {
  const { i18n } = useTranslation();
  const dir: Direction = RTL_LANGUAGES.includes(i18n.language as (typeof RTL_LANGUAGES)[number]) ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = dir;
  }, [i18n.language, dir]);

  return dir;
}
